var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5795,
    cy: 7.21978,
    r: 5.21978,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29972 19.6993C3.29832 19.3323 3.38038 18.9699 3.53971 18.6393C4.03969 17.6394 5.44963 17.1094 6.61958 16.8694C7.46335 16.6893 8.31877 16.569 9.17947 16.5094C10.773 16.3694 12.3757 16.3694 13.9693 16.5094C14.8299 16.5697 15.6853 16.69 16.5292 16.8694C17.6991 17.1094 19.1091 17.5894 19.609 18.6393C19.9294 19.3131 19.9294 20.0954 19.609 20.7692C19.1091 21.8192 17.6991 22.2992 16.5292 22.5291C15.6864 22.7167 14.8307 22.8403 13.9693 22.8991C12.6723 23.0091 11.3692 23.0291 10.0694 22.9591C9.76945 22.9591 9.47946 22.9591 9.17947 22.8991C8.32131 22.8411 7.46885 22.7174 6.62958 22.5291C5.44963 22.2992 4.04969 21.8192 3.53971 20.7692C3.3812 20.4348 3.29921 20.0693 3.29972 19.6993Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.b5a08267caddfa7f0e5391108113e13f.svg";
export { ForwardRef as ReactComponent };